import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import '../styles/FloatingActions.css';

const FloatingActions = () => {
  const [showTopButton, setShowTopButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowTopButton(window.scrollY > 360);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <motion.a
        className="floating-action whatsapp-action"
        href="https://wa.me/905496935858"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp ile iletişime geç"
        initial={{ opacity: 0, x: -24, scale: 0.9 }}
        animate={{ opacity: 1, x: 0, scale: 1 }}
        transition={{ duration: 0.45, ease: 'easeOut' }}
        whileHover={{ y: -4, scale: 1.06 }}
        whileTap={{ scale: 0.96 }}
      >
        <span className="floating-pulse" />
        <svg viewBox="0 0 32 32" aria-hidden="true">
          <path d="M16.02 4.8c-6.11 0-11.08 4.88-11.08 10.89 0 1.94.53 3.83 1.54 5.48L4.8 27.2l6.22-1.62a11.27 11.27 0 0 0 5 1.18c6.11 0 11.08-4.88 11.08-10.89S22.13 4.8 16.02 4.8Zm0 19.98c-1.63 0-3.22-.43-4.61-1.25l-.33-.2-3.69.96.99-3.55-.22-.36a8.83 8.83 0 0 1-1.35-4.69c0-4.9 4.13-8.89 9.21-8.89s9.21 3.99 9.21 8.89-4.13 9.09-9.21 9.09Zm5.05-6.66c-.28-.14-1.64-.8-1.89-.89-.25-.1-.44-.14-.62.14-.18.27-.71.89-.87 1.07-.16.18-.32.2-.6.07-.28-.14-1.17-.43-2.23-1.36-.82-.73-1.38-1.63-1.54-1.9-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.48.14-.16.18-.27.28-.46.09-.18.05-.34-.02-.48-.07-.14-.62-1.47-.85-2.01-.22-.53-.45-.46-.62-.47h-.53c-.18 0-.48.07-.73.34-.25.28-.96.93-.96 2.26s.99 2.62 1.12 2.8c.14.18 1.94 2.91 4.7 4.08.66.28 1.17.45 1.57.58.66.21 1.26.18 1.73.11.53-.08 1.64-.66 1.87-1.3.23-.64.23-1.18.16-1.3-.07-.12-.25-.19-.53-.33Z" />
        </svg>
      </motion.a>

      <AnimatePresence>
        {showTopButton && (
          <motion.button
            type="button"
            className="floating-action to-top-action"
            onClick={scrollToTop}
            aria-label="Yukarı çık"
            initial={{ opacity: 0, x: 24, scale: 0.88 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 24, scale: 0.88 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
            whileHover={{ y: -4, scale: 1.06 }}
            whileTap={{ scale: 0.96 }}
          >
            <FontAwesomeIcon icon={faChevronUp} />
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
};

export default FloatingActions;
